import TagManager from '@accor/core-services/dist/gtm/index';
import { loadGTM, pushToDataLayer } from "./google-tag-manager";

/**
 * Monkey patch TagManager as a workaround to prevent it from loading Google Tag Manager from ace-frontend.
 * Because Fairmont needs to load it through a subdomain acting as a proxy to avoid lost traffic due to adblockers.
 * initDefaultAutoTracking is the method that loads the GTM script in ace-frontend while trackEvent depends on it to be fired.
 */
TagManager.initDefaultAutoTracking = async function () {
  console.debug("## TagManager - initDefaultAutoTracking override");
  try {
    await loadGTM();
    console.debug('## GTM - Loading script success');
  } catch (error) {
    console.warn('## GTM - Loading script error', error);
  }
}

TagManager.trackEvent = (data: Record<string, unknown>) => {
  console.debug("## TagManager - trackEvent override");
  pushToDataLayer(data);
}

// On ace-frontend side, TagManager is often used as a singleton, so we need to override the global instance
window.TagManager = TagManager;
